export default {
  setFilters(state, filters) {
    state.activeFilters = filters
  },

  updateFilters(state, filters) {
    state.activeFilters = { ...state.activeFilters, ...filters }
  },

  clearFilters(state) {
    state.activeFilters = {}
  },

  setActiveDashboard(state, dashboardId) {
    state.activeDashboardId = dashboardId
  },

  setDashboardConfig(state, config) {
    state.dashboardConfig = config
  },

  setChartsDataByTabId(state, { tabId, value }) {
    state.chartsData = { ...state.chartsData, [tabId]: value }
  },

  setChartsLoadingByTabId(state, { tabId, value }) {
    state.chartsLoading = { ...state.chartsLoading, [tabId]: value }
  },

  setChartsErrorsByTabId(state, { tabId, value }) {
    state.chartsErrors = { ...state.chartsErrors, [tabId]: value }
  },

  setIndicatorsByTabId(state, { tabId, value }) {
    state.indicators = { ...state.indicators, [tabId]: value }
  },

  updateChartsDataByTabId(state, { tabId, value }) {
    state.chartsData = {
      ...state.chartsData,
      [tabId]: { ...state.chartsData[tabId], ...value }
    }
  },

  updateChartsLoadingByTabId(state, { tabId, value }) {
    state.chartsLoading = {
      ...state.chartsLoading,
      [tabId]: { ...state.chartsLoading[tabId], ...value }
    }
  },

  updateChartsErrorsByTabId(state, { tabId, value }) {
    state.chartsErrors = {
      ...state.chartsErrors,
      [tabId]: { ...state.chartsErrors[tabId], ...value }
    }
  },

  setFilterFieldOptions(state, filterOptions) {
    state.filterFieldOptions = filterOptions
  },

  resetInactiveTabs(state, activeTabId) {
    state.chartsData = { [activeTabId]: state.chartsData[activeTabId] }
    state.chartsLoading = { [activeTabId]: state.chartsLoading[activeTabId] }
    state.chartsErrors = { [activeTabId]: state.chartsErrors[activeTabId] }
    state.indicators = { [activeTabId]: state.indicators[activeTabId] }
  }
}
